
// English strings
define(
    '../nls/resistance-in-a-wire-strings',{
      "root": {
        simTitle: "Resistance in a Wire",
        cm: "cm",
        ohm: "ohm",
        resistivity: "resistivity",
        length: "length",
        area: "area",
        resistanceEq: "Resistance ="
      },
      "am": true,
      "ar": true,
      "ar-sa": true,
      "da": true,
      "de": true,
      "el": true,
      "es": true,
      "es-pe": true,
      "et": true,
      "eu": true,
      "fa": true,
      "fi": true,
      "fr": true,
      "gl": true,
      "hr": true,
      "hu": true,
      "in": true,
      "it": true,
      "iw": true,
      "ja": true,
      "ka": true,
      "ko": true,
      "lv": true,
      "mk": true,
      "mn": true,
      "nl": true,
      "pl": true,
      "pt": true,
      "pt-br": true,
      "ro": true,
      "ru": true,
      "sk": true,
      "sr": true,
      "sv": true,
      "tk": true,
      "tr": true,
      "vi": true,
      "zh-cn": true,
      "zh-tw": true
    } );